import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import PokazCennikContainer from "./pokazCennik/PokazCennikContainer";
import GenerujCennikContainer from "./generujCennik/GenerujCennikContainer";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import ZnizkiService from "../znizki/ZnizkiService";
import PokazCenyZeZnizkami from "./pokażCenyZeZnizkami/PokazCenyZeZnizkami";
import LSService from "../../../../utilities/localStorageService/LSService";

export default class CenyBiletowContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            trasy: [],
            znizki: [],
            wyszukajCennik: null,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)

    }

    componentDidMount() {
        this.pobierzTrasy();
        this.pobierzZnizki();

        if (Boolean(LSService.pobierzObiektDoWyszukaniaCennika())) {
            this.setState({wyszukajCennik: LSService.pobierzObiektDoWyszukaniaCennika()})
            LSService.usunObiektDoWyszukaniaCennika()
        }
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            let arr = Array.from(response.data.content.filter(i => i.status >= 0))

            arr.sort((a, b) => {
                if (a.nazMiOd === "Rzeszów" && a.idTr < b.idTr) return -1
                else return 1
            })


            this.setState({trasy: arr})
        }.bind(this))
    }

    pobierzZnizki() {
        ZnizkiService.getZnizki().then(function (response) {

            this.setState({
                znizki: response.data.content.sort((a, b) => {
                    if (a.czyMies && !b.czyMies) return 1
                    else return -1
                })
            })

        }.bind(this))
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <PokazCennikContainer trasy={this.state.trasy} znizki={this.state.znizki} wyszukajCennik={this.state.wyszukajCennik}/>
        }
        else if (this.state.activeTab === 2) {
            return <PokazCenyZeZnizkami trasy={this.state.trasy}/>
        }
        else {
            return <GenerujCennikContainer trasy={this.state.trasy} znizki={this.state.znizki}/>
        }
    }

    changeActiveTab(eventKey) {
        this.setState({activeTab: eventKey})
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/ceny-biletow', text: 'Ceny biletów'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="home-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Pokaż cennik">
                                </Tab>
                                <Tab eventKey={2} title="Pokaż ceny ze zniżkami">
                                </Tab>
                                <Tab eventKey={3} title="Generuj cennik">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop: '15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/CenyBiletowContainer.js